import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CxFormsModule } from '@forms';

import { SchedulerComponent } from './scheduler.component';
import { SchedulerTemplates } from './scheduler-templates.directive';
import { UiMessagesModule } from '@ui-messages';

@NgModule({
    imports: [
        CommonModule,
        CxFormsModule,
        UiMessagesModule
    ],
    declarations: [
        SchedulerComponent,
        SchedulerTemplates
    ],
    exports: [
        SchedulerComponent,
        SchedulerTemplates
    ],
    providers: []
})
export class SchedulerModule { }

export {
    SchedulerComponent
}
